/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InActive/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2NotificationIcon from 'DesignSystem/Svgs/Tysiav2NotificationIcon/index'



/** @type {import('Simple/types.js').View} */
export default function InActive({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/MessageIndicatorIcon/Content/InActive"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<Tysiav2NotificationIcon
  viewPath={`${viewPath}/Tysiav2NotificationIcon`}
 width={14}
 height={14}
 fill={dtColorsWhite}
/>
{children}
</React.Fragment>)
}